import { Expose, Type } from 'class-transformer';
import { MyActivityInvitedUsersDto } from './my-activity-invited-users.dto';

export class MyActivityAllocDto {
  @Expose({ name: 'date' })
  date: string;
  @Expose({ name: 'end_time' })
  endTime: string;
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'number_of_participants' })
  numberOfParticipants: number;
  @Expose({ name: 'resource_id' })
  resourceId: number;
  @Expose({ name: 'start_time' })
  startTime: string;
  @Expose({ name: 'user_id' })
  userId: number;
  @Expose({ name: 'admin_message' })
  admin_message?: string;
  @Expose({ name: 'user_message' })
  user_message?: string;
  @Expose({ name: 'invited_users' })
  @Type(() => MyActivityInvitedUsersDto)
  invited_users: MyActivityInvitedUsersDto[];
  @Expose({ name: 'department_name' })
  department_name?: string;
  @Expose({ name: 'meeting_subject' })
  meeting_subject?: string;
}
